import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { ServicesGrid } from './components/ServicesGrid';
import { BrandsStrip } from './components/BrandsStrip';
import { WhyChooseUs } from './components/WhyChooseUs';
import { PhotoGallery } from './components/PhotoGallery';
import { LocationCard } from './components/LocationCard';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-[#c41e3a] selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BrandsStrip data-id="element-4" />
        <ServicesGrid data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <PhotoGallery data-id="element-7" />
        <LocationCard data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}